module.exports = __webpack_public_path__ + "img/2Dline_selected.ddec47d2.png";